"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const area_1 = require("./area");
const silo_1 = require("./silo");
const brand_1 = require("./brand");
const driver_1 = require("./driver");
const hauler_1 = require("./hauler");
const stockpile_1 = require("./stockpile");
const hopper_1 = require("./hopper");
const contractor_1 = require("./contractor");
const dump_truck_1 = require("./dump-truck");
const excavator_1 = require("./excavator");
const pit_1 = require("./pit");
const vessel_1 = require("./vessel");
const seam_1 = require("./seam");
const masterDataReducer = (0, redux_1.combineReducers)({
    area: area_1.areaReducer,
    silo: silo_1.siloReducer,
    brand: brand_1.brandReducer,
    driver: driver_1.driverReducer,
    hauler: hauler_1.haulerReducer,
    stockpile: stockpile_1.stockpileReducer,
    hopper: hopper_1.hopperReducer,
    contractor: contractor_1.contractorReducer,
    dumpTruck: dump_truck_1.dumpTruckReducer,
    excavator: excavator_1.excavatorReducer,
    pit: pit_1.pitReducer,
    vessel: vessel_1.vesselReducer,
    seam: seam_1.seamReducer,
});
exports.default = masterDataReducer;
